import { render, staticRenderFns } from "./feedbackDetails.vue?vue&type=template&id=6f862771&"
import script from "./feedbackDetails.vue?vue&type=script&lang=js&"
export * from "./feedbackDetails.vue?vue&type=script&lang=js&"
import style0 from "./feedbackDetails.vue?vue&type=style&index=0&id=6f862771&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports